import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const SearchFilters = ({ onFiltersChange, activeFilters = {} }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [filters, setFilters] = useState({
    location: activeFilters?.location || '',
    mutualFriends: activeFilters?.mutualFriends || false,
    recentlyActive: activeFilters?.recentlyActive || false,
    ...activeFilters
  });

  const locations = [
    'New York, NY',
    'Los Angeles, CA',
    'Chicago, IL',
    'Houston, TX',
    'Phoenix, AZ',
    'Philadelphia, PA',
    'San Antonio, TX',
    'San Diego, CA'
  ];

  const handleFilterChange = (key, value) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    onFiltersChange(newFilters);
  };

  const clearAllFilters = () => {
    const clearedFilters = {
      location: '',
      mutualFriends: false,
      recentlyActive: false
    };
    setFilters(clearedFilters);
    onFiltersChange(clearedFilters);
  };

  const hasActiveFilters = Object.values(filters)?.some(value => 
    value === true || (typeof value === 'string' && value?.length > 0)
  );

  return (
    <div className="bg-card border border-border rounded-xl p-4">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold text-foreground flex items-center">
          <Icon name="Filter" size={18} className="mr-2" />
          Filters
        </h3>
        
        <div className="flex items-center space-x-2">
          {hasActiveFilters && (
            <Button
              variant="ghost"
              size="sm"
              onClick={clearAllFilters}
              className="text-muted-foreground hover:text-foreground"
            >
              Clear All
            </Button>
          )}
          
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setIsExpanded(!isExpanded)}
            className="sm:hidden"
          >
            <Icon 
              name={isExpanded ? "ChevronUp" : "ChevronDown"} 
              size={18} 
            />
          </Button>
        </div>
      </div>
      <div className={`mt-4 space-y-4 ${isExpanded ? 'block' : 'hidden sm:block'}`}>
        {/* Location Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Location
          </label>
          <select
            value={filters?.location}
            onChange={(e) => handleFilterChange('location', e?.target?.value)}
            className="w-full px-3 py-2 bg-surface border border-border rounded-lg text-foreground focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-150"
          >
            <option value="">Any location</option>
            {locations?.map((location) => (
              <option key={location} value={location}>
                {location}
              </option>
            ))}
          </select>
        </div>

        {/* Checkbox Filters */}
        <div className="space-y-3">
          <Checkbox
            label="Has mutual friends"
            checked={filters?.mutualFriends}
            onChange={(e) => handleFilterChange('mutualFriends', e?.target?.checked)}
          />
          
          <Checkbox
            label="Recently active"
            description="Active in the last 7 days"
            checked={filters?.recentlyActive}
            onChange={(e) => handleFilterChange('recentlyActive', e?.target?.checked)}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchFilters;